import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

export default new VueRouter({
    routes: [
        { path: '/', component: () => import('../components/title.vue') },
        { path: '/start', component: () => import('../components/step1.start.vue') },
        { path: '/company', component: () => import('../components/step2.company.vue') },
        { path: '/contacts', component: () => import('../components/step3.contacts.vue') },
        { path: '/points', component: () => import('../components/step4.points.vue') },
        { path: '/files', component: () => import('../components/step5.files.vue') },
        { path: '/validation', component: () => import('../components/step6.validation.vue') },
        { path: '/finish', component: () => import('../components/step7.finish.vue') }, 
        { path: '/error', component: () => import('../components/error.vue') },
        { path: '/show/:uuid', component: () => import('../components/show.vue'), props: true }, 
        { path: '/show', component: () => import('../components/show.vue'), props: true }, 
    ]
})